import './TaxonomyIngestion.scss'
import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../stores";
import {Alert, Button, ButtonGroup, Chip, Grid, IconButton, Typography} from "@mui/material";
import {routes} from '../../routing/routes';
import {generatePath, useNavigate} from "react-router";
import {KoiFacade} from "../../components/koi-facade/KoiFacade";
import {ChevronRight, Refresh} from '@mui/icons-material';
import {LoadingSpinnerPie} from "../../components/loading-pie/LoadingSpinnerPie";
import moment from "moment";


export const TaxonomyOverviewPage: React.FC = observer(() => {
    const {taxonomyIngestionStore, p} = useStores();
    const loading = taxonomyIngestionStore.taxonomyList === undefined;
    const noData = taxonomyIngestionStore.taxonomyList?.length === 0;
    const manyData = taxonomyIngestionStore.taxonomyList && taxonomyIngestionStore.taxonomyList.length > 9;
    const error = taxonomyIngestionStore.taxonomyListManager.error;

    const navigate = useNavigate();
    useEffect(() => {
        taxonomyIngestionStore.taxonomyListManager.request()
    }, [taxonomyIngestionStore, p])

    const uploadButton = <Button
        onClick={() => navigate(generatePath(routes.taxonomy_upload))}
        color="primary"
        variant="outlined"
        endIcon={<ChevronRight/>}
    >
        Upload new taxonomy
    </Button>;

    const actions = <Grid container className="dataset-overview-actions" justifyContent="center">
        <Grid>
            {uploadButton}
        </Grid>
    </Grid>

    const table = <>
        <Grid container justifyContent="center" sx={{mt: 10, mb: 4}}>
            <Grid size={6}>
                <Typography variant="h6">Taxonomy name</Typography>
            </Grid>
            <Grid size={2}>
                <Typography variant="h6">Status</Typography>
            </Grid>
            <Grid size={2}>
                <Typography variant="h6">Upload date</Typography>
            </Grid>
            <Grid size={2}/>
        </Grid>

        {taxonomyIngestionStore.taxonomyList?.map((taxonomyFile) => (
            <Grid key={'dataset' + taxonomyFile.id} container justifyContent="center" sx={{mb: 2}}>
                <Grid size={6}>
                    <Typography variant="body1">{taxonomyFile.name}</Typography>
                </Grid>
                <Grid size={2}>
                    <Typography variant="body1">
                        {taxonomyFile.completed ?
                            <Chip label="Uploaded" color="success"
                                  className="dataset-uploaded"/> :
                            <Chip label="Pending" color="primary"
                                  className="dataset-pending"/>
                        }
                    </Typography>
                </Grid>
                <Grid size={2}>
                    <Typography variant="body1">{moment(taxonomyFile.date).format('YYYY-MM-DD')} </Typography>
                </Grid>
                <Grid style={{textAlign: 'right'}} size={2}>
                    <ButtonGroup variant="outlined" color="primary">
                        {/*{!taxonomyFile.completed &&*/}
                        {/*    <Button color="error" onClick={() => setDeleteDialogSubject(taxonomyFile)}>*/}
                        {/*        <Delete/>*/}
                        {/*    </Button>*/}
                        {/*}*/}
                        <Button
                            onClick={() => navigate(generatePath(routes.taxonomy_upload_mapping, {dataFileId: String(taxonomyFile.id)}))}>
                            <ChevronRight/>
                        </Button>
                    </ButtonGroup>
                </Grid>
            </Grid>
        ))}
    </>

    return (
        <KoiFacade
            title='Taxonomy Ingestion'
            onBack={() => navigate(routes.home)}
            className={`taxonomy-ingestion data-overview-page${noData ? ' no-data' : ''}`}
            next={manyData ? {type: 'component', node: uploadButton} : undefined}>
            <Grid container justifyContent="center" className={error ? 'error-alert-container' : ''}>
                {error
                    ? <Grid>
                        <Alert
                            severity="error"
                            action={<IconButton
                                size="small"
                                onClick={() => taxonomyIngestionStore.taxonomyListManager.request()}
                                disabled={taxonomyIngestionStore.taxonomyListManager.busy}>
                                <Refresh/>
                            </IconButton>
                            }>
                            {error}
                        </Alert>
                    </Grid>
                    : loading
                        ? <Grid><LoadingSpinnerPie/></Grid>
                        : noData
                            ? actions
                            : <Grid size={8}>
                                {table}
                                {actions}
                            </Grid>
                }
            </Grid>
        </KoiFacade>
    );
});
